import { render, staticRenderFns } from "./local-card.vue?vue&type=template&id=5dfc9bae&scoped=true&"
import script from "./local-card.vue?vue&type=script&lang=js&"
export * from "./local-card.vue?vue&type=script&lang=js&"
import style0 from "./local-card.vue?vue&type=style&index=0&id=5dfc9bae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc9bae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
